import { ShareWithLegalEntitySIDTO } from "../../../../../models/share-with-legal-entity-si";

export const getItemsToSave = (
  originItems: ShareWithLegalEntitySIDTO[],
  modifiedItems: ShareWithLegalEntitySIDTO[]
): ShareWithLegalEntitySIDTO[] => {
  const originItemsIds: Record<string, boolean> = {};

  originItems.forEach((_item) => {
    const itemId = _item.id;

    if (itemId) {
      originItemsIds[itemId] = true;
    }
  });

  const res = modifiedItems.filter((item) => !item?.isDeleted || (!!item?.isDeleted && !!originItemsIds[item.id]));

  return res;
};
